import { z } from 'zod';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

const makeUnvalidatableInput = bindUnvalidatableInputMaker();
const markCharactersWhitespaceInput = makeUnvalidatableInput({
  schema: z.object({
    type: z.literal("Whitespace"),
    character: z.string()
  }).transform(it => ({
    id: "whitespace",
    type: "Whitespace",
    nodeType: "mark-characters-whitespace",
    as: it.character === " " ? "space" : "newline"
  }))
});

export { markCharactersWhitespaceInput };
//# sourceMappingURL=input.whitespace.js.map
